<iframe [src]="iframeUrl" id="graphing-iframe" style="width: 508px; height: 608px;"></iframe>